export default function hash(string: string): string {
  if (string.length === 0) {
    return '0';
  }

  let hash = 0;
  for (let i = 0; i < string.length; i++) {
    const char = string.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0;
  }

  if (hash < 0) {
    hash *= -1;
  }

  return hash.toString();
}
